import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'enrollment-office',
    templateUrl: './enrollment-office.component.html',
    styleUrls: ['./enrollment-office.component.scss'],
    standalone: false
})
export class EnrollmentOfficeComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  enrollmentOffices: any = [
    { id: 'RG', value: 'Régime général (CPAM)' },
    { id: 'RA', value: 'Régime agricole' },
    { id: 'RSI', value: 'RSI ou caisse des indépendants' },
    { id: 'SCNF', value: 'SNCF' },
    { id: 'RATP', value: 'RATP' },
    { id: 'MC', value: 'Militaires de carrière' },
    { id: 'CFE', value: "Caisse des Français de l'étranger" },
    { id: 'MGEN', value: "Mutuelle Générale de l'Éducation Nationale (MGEN)" },
    { id: 'MNH', value: 'Mutuelle Nationale des Hospitaliers (MNH)' },
  ];
  sessionConsultant: boolean = false;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.sessionConsultant =
      !!pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
